var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('automation-and-query-maker',{attrs:{"options":_vm.options,"query":_vm.query},on:{"change":function($event){return _vm.syncQuery($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }